<template>
  <el-dialog
  :title="title"
  :visible.sync="dialogVisible"
  width="600px"
  top="10vh"
 :show-close="true"
 :modal-append-to-body="true"
 :close-on-click-modal="false"
 :close-on-press-escape="false"
 append-to-body
 @close="closeDialog"
 >
    <div class="panel">
        <el-form ref="fieldForm" :model="form" :rules="formRules" label-width="110px">
             <el-row :gutter="5">
                 <el-col :span="24">
                     <el-form-item label="字段名称" prop="fieldName">
                         <el-input size="small" v-model="form.fieldName" placeholder="输入字段名称"></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="24">
                     <el-form-item label="字段类型" prop="fieldType">
                          <el-select
                             v-model="form.fieldType"
                             clearable
                             filterable
                             placeholder="请选择"
                             style="width:100%;"
                             size="small"
                         >
                             <el-option
                             v-for="item in orderStatusList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"
                             ></el-option>
                         </el-select>
                     </el-form-item>
                 </el-col>



             </el-row>
             <!-- v-if="form.fieldType == '0' || form.fieldType == '1' ||  form.fieldType == '2'
             || form.fieldType == '3' ||   form.fieldType == '4' ||  form.fieldType == '5' " -->
             <el-row v-if="form.fieldType == '单选框' || form.fieldType == '复选框'">
                <el-col :span="24" v-if="form.fieldType == '0'">
                     <el-form-item label="允许扫码输入" prop="allowQRCode">
                          <el-select
                             v-model="form.allowQRCode"
                             clearable
                             filterable
                             placeholder="请选择"
                             style="width:100%;"
                             size="small"
                         >
                             <el-option
                             v-for="item in allowQRCodeList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"
                             ></el-option>
                         </el-select>
                     </el-form-item>
                 </el-col>

                <el-col :span="24" v-if="form.fieldType == '文本'">
                     <el-form-item label="可修改扫码结果" prop="allowUpdate">
                          <el-select
                             v-model="form.allowUpdate"
                             clearable
                             filterable
                             placeholder="请选择"
                             style="width:100%;"
                             size="small"
                         >
                             <el-option
                             v-for="item in allowUpdateList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"
                             ></el-option>
                         </el-select>
                     </el-form-item>
                </el-col>
                <el-col :span="24" v-if="form.fieldType == '单选框'">
                     <el-form-item label="设置可选范围">
                         <el-table
                            :data="radioScope"
                            style="width: 100%" border size="mini">

                            <el-table-column label="操作" width="60">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)"></el-button>

                                </template>
                            </el-table-column>
                            <el-table-column label="可选范围">
                                <template slot-scope="scope">
                                   <el-input type="text" v-model="scope.row.label" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="设为默认值" width="90">
                                <template slot-scope="scope">
                                   <el-checkbox v-model="scope.row.checked" @change="defaultChange(scope.$index, scope.row)"></el-checkbox>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div>
                            <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAdd">新增可选项</el-button>
                        </div>
                     </el-form-item>
                </el-col>

                <el-col :span="24" v-if="form.fieldType == '复选框'">
                     <el-form-item label="设置可选范围">
                         <el-table
                            :data="selectScope"
                            style="width: 100%" border size="mini">

                            <el-table-column label="操作" width="60">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="selectDel(scope.$index, scope.row)"></el-button>

                                </template>
                            </el-table-column>
                            <el-table-column label="可选范围">
                                <template slot-scope="scope">
                                   <el-input type="text" v-model="scope.row.label" size="mini"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div>
                            <el-button type="primary" size="mini" icon="el-icon-plus" @click="selectAdd">新增可选项</el-button>
                        </div>
                     </el-form-item>
                </el-col>

                <el-col :span="24" v-if="false">
                     <el-form-item label="隐藏条件">
                         <el-button size="small" type="primary" plain icon="el-icon-plus">主要按钮</el-button>
                     </el-form-item>
                 </el-col>

                 <el-col :span="24" v-if="false">
                     <el-form-item label="字段属性">
                           <el-checkbox-group v-model="checkList" @change="typeChange">
                                <el-checkbox label="只读" :disabled="flag1 && flag2 " v-if="form.fieldType != '3' && form.fieldType != '4'"></el-checkbox>
                                <el-checkbox label="多行" v-if="form.fieldType == '0'"></el-checkbox>
                                <el-checkbox label="必填" :disabled="!flag1 && flag2"></el-checkbox>
                                <el-checkbox label="显示千分位分割符" v-if="form.fieldType == '文本'"></el-checkbox>
                                <el-checkbox label="小数位数" v-if="form.fieldType == '文本'"></el-checkbox>
                                <el-input size="small" v-model="form.guideTxt" style="width:80px;" v-if="form.fieldType == '文本'"></el-input>
                                <el-checkbox label="默认值" v-if="form.fieldType == '文本' || form.fieldType == '数字' "></el-checkbox>
                                <el-input size="small" v-model="form.default1" style="width:80px;" v-if="form.fieldType == '文本'"></el-input>
                                  <el-select
                                        v-if="form.fieldType == '数字'"
                                        v-model="form.default2"
                                        clearable
                                        filterable
                                        placeholder="请选择"
                                        style="width:80px;"
                                        size="small"
                                    >
                                        <el-option
                                        v-for="item in defaultList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        ></el-option>
                                    </el-select>
                            </el-checkbox-group>
                     </el-form-item>
                 </el-col>
                <!-- <el-col :span="24" v-if="form.fieldType != '2' && form.fieldType != '3' && form.fieldType != '4'">
                     <el-form-item label="引导文字">
                         <el-input size="small" v-model="form.guideTxt" placeholder="填写完显示在框里"></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="24" v-if="form.fieldType != '2' && form.fieldType != '3' && form.fieldType != '4'">
                     <el-form-item label="提示说明">
                         <el-input type="textarea" v-model="form.prompt" maxlength="50" show-word-limit></el-input>
                     </el-form-item>
                 </el-col> -->

                <el-col :span="24" v-if="form.fieldType == '数字'">
                     <el-form-item label="显示精度">
                          <el-select
                             v-model="form.showAccuracy"
                             clearable
                             filterable
                             placeholder="请选择"
                             style="width:100%;"
                             size="small"
                         >
                             <el-option
                             v-for="item in showAccuracyList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"
                             ></el-option>
                         </el-select>
                     </el-form-item>
                </el-col>


             </el-row>
        </el-form>


    </div>
    <div class="panel-bottom">
         <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
         <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
     </div>

 </el-dialog>
</template>
<script>
export default {
 name:'addField',
 props:{
     diaVisible:{
         type:Boolean,
         default:false,
     },
     fieldData:{
         type:Object,
         default:function(){
             return {};
         }
     },


 },
 watch:{
     diaVisible(newVal,oldVal){
         if(newVal){
             this.dialogVisible = newVal;
         }
     },
     fieldData(newVal,oldVal){
         if(newVal['_id']){
          this.title = '编辑自定义字段';
          this.form = JSON.parse(JSON.stringify(newVal));
          this.radioScope = this.form['fieldInfo']['radioScope'] || [];
          this.selectScope = this.form['fieldInfo']['selectScope'] || [];
         }else{
          this.title = '创建自定义字段';
          this.form = {
            fieldName:'',
            fieldType:'',
          }
         }
     }
 },
 data(){
     return{
         radioScope:[],
         selectScope:[],
         dialogVisible: false,
         flag1:false,
         flag2:false,
         form:{
           fieldName:'',
           fieldType:'',
         },
         formRules:{
             fieldName:[
                 {
                     required: true,
                     message: "请输入字段名称",
                     trigger: "blur",
                 }

             ],
             fieldType:[
                 {
                     required: true,
                     message: "请选择字段类型",
                     trigger: "blur",
                 }
             ]
         },
         orderStatusList: [
          { label: "文本", value: "文本" },
          { label: "数字", value: "数字" },
          { label: "时间", value: "时间"},
          // {label: "附件", value: "附件" },
          // {label: "图片",value: "图片"},
          {label: "单选框",value: "单选框"},
          {label: "复选框",value: "复选框"},
        ],
        allowQRCodeList:[
            { label: "否", value: "0" },
            { label: "是", value: "1" },
        ],
        allowUpdateList:[
            { label: "否", value: "0" },
            { label: "是", value: "1" },
        ],
        checkList:[],
        showAccuracyList:[
            { label: "年-月-日", value: "0" },
            { label: "年-月-日 时", value: "1" },
            { label: "年-月-日 时:分", value: "2" },
            { label: "年-月-日 时:分:秒", value: "3" },
            { label: "时:分:秒", value: "4" },
        ],
        defaultList:[
            { label: "当前时间", value: "0" },
        ],
        title:'创建自定义字段',

     }
 },
 created(){

 },
 methods:{
     handleSave(){
         this.$refs["fieldForm"].validate((valid) => {
             if (valid) {
                if(this.form.fieldType == '文本' || this.form.fieldType == '数字' || this.form.fieldType == '时间'){
                  this.form['fieldInfo'] = {};
                }else{

                  if(this.radioScope.length > 0 || this.selectScope.length > 0){

                      this.form['fieldInfo'] = {};
                  }
                  if(this.radioScope.length > 0){
                      this.form['fieldInfo']['radioScope'] = this.radioScope;
                  }
                  if(this.selectScope.length > 0){
                      this.form['fieldInfo']['selectScope'] = this.selectScope;
                  }
                }
                this.dialogVisible = false;
                this.$emit('save',this.form);
             }
         })

     },

     closeDialog(){
         setTimeout(() => {
             this.dialogVisible = false;
             this.$parent.createProductPanVisible = false;
         }, 100);
     },
     typeChange(val){
         let list1 = val.filter(item=>item == '只读');
         let list2 = val.filter(item=>item == '必填');
         if(list1.length>0){
             this.flag1 = false;
             this.flag2 = true;
         }else if(list2.length > 0){
             this.flag1 = true;
             this.flag2 = true;
         }else{
             this.flag1 = false;
             this.flag2 = false;
         }

     },
     handleAdd(){
         let obj = {
             checked:false,
             label:''
         };
         this.radioScope.push(obj);
     },
     handleDelete(index,row){
         this.radioScope.splice(index,1);
     },
     selectDel(index,row){
         this.selectScope.splice(index,1);
     },
    selectAdd(){
         let obj = {
             label:''
         };
         this.selectScope.push(obj);
     },
     defaultChange(index,row){
         for(let i = 0;i<this.radioScope.length;i++){
             if(i != index){
                 this.radioScope[i]['checked'] = false;
             }
         }

     }
 }

}
</script>
<style scoped>
 .panel{
     /* width: 100%; */
     max-height: 70%;

     overflow-y: auto;
     overflow-x: hidden;
     /* padding: 0px 50px; */
 }

 .panel-bottom{
     width: 100%;
     height: 40px;
     line-height: 40px;
     padding-top: 20px;
     text-align: center;
 }
 .panel-bottom el-button{
     margin: 10px 0 0 10px;
 }


</style>



// WEBPACK FOOTER //
// src/views/customSetting/production/addField.vue